import shlg from '../../assets/navigation/sh-lg.png'
import wblg from '../../assets/navigation/wb-lg.png'
import { isMobile } from 'react-device-detect'


const cloudfrontTest = 'https://d1epvrxk8md14j.cloudfront.net/mapData/wb/wb512v4/600/'
const s3Test = 'https://s3mapdatastoragebucket82d4a-dev.s3.amazonaws.com/mapData/wb/wb1024v4/600/15/5190/11096.jpg'
const tileRangeSpearhead = {
  13: { xMin: 2000, xMax: 3000, yMin: 2500, yMax: 3500 },
  14: { xMin: 4000, xMax: 6000, yMin: 5000, yMax: 7000 },
  15: { xMin: 8000, xMax: 12000, yMin: 10000, yMax: 14000 },
  16: { xMin: 16000, xMax: 24000, yMin: 20000, yMax: 28000 },
  17: { xMin: 32000, xMax: 48000, yMin: 40000, yMax: 56000 }
};
  const tileRangeWB = {
  13: { xMin: 1296, xMax: 1300, yMin: 2773, yMax: 2777 },
  14: { xMin: 2593, xMax: 2600, yMin: 5547, yMax: 5554 },
  15: { xMin: 5187, xMax: 5201, yMin: 11095, yMax: 11108 },
  16: { xMin: 10374, xMax: 10402, yMin: 22191, yMax: 22216 },
  17: { xMin: 20749, xMax: 20805, yMin: 44382, yMax: 44433 },
  18: { xMin: 41499, xMax: 41611, yMin: 88764, yMax: 88867 }
};

const mapData = {
    WhistlerBlackcomb: {
        mapName:'Whistler Blackcomb',
        map:'WB2025',
        version: '2025',
        lastUpdated: 'March 05,2025',
        projection: 'UTM Zone 10N',
        datum: 'NAD83',
        contourInterval: '10m',
        scale: '1:3,937',
        offlineAvailable:false,
        offlineComingSoon:true,
        downloadURL:'https://d1epvrxk8md14j.cloudfront.net/mapData/wb/currentv1/{z}/{x}/{y}.jpeg',
        img:wblg,
        center:[50.063541599446594, -122.94765848949606 ],
        maxBounds:[[50.03372798633418, -123.00894714633222], [50.12334633850441, -122.85628672950945]],
        minZoom:13,
        maxZoom:18,
        defaultZoom:14,
        //tileSize:256,
        tileLayerBaseUrl:'https://d1epvrxk8md14j.cloudfront.net/mapData/wb/currentv1/',
        tileRange:tileRangeWB,
        layerType:'multi'
    },
/*
    wb512600: {
        mapName:isMobile?'Whistler Blackcomb (High-Res)':'Whistler Blackcomb (Lo-Res)',
        map:isMobile?'WBHighRes':'WBLowRes',
        version: '2025',
        lastUpdated: 'March 05,2025',
        projection: 'UTM Zone 10N',
        datum: 'NAD83',
        contourInterval: '10m',
        scale: '1:3,937',
        offlineAvailable:false,
        offlineComingSoon:false,
        downloadURL:'',
        img:wblg,
        center:[50.063541599446594, -122.94765848949606],
        maxBounds:[[50.03372798633418, -123.00894714633222], [50.12334633850441, -122.85628672950945]],
        minZoom:13,
        maxZoom:18,
        tileSize:512,
        tileLayerBaseUrl:'https://d1epvrxk8md14j.cloudfront.net/mapData/wb/wb512v4/600/',
        tileRange:tileRangeWB,
    },
        wb1024600: {
        mapName:'Whistler Blackcomb (High-Res)',
        map:'WBHighRes',
        version: '2025',
        lastUpdated: 'March 05,2025',
        projection: 'UTM Zone 10N',
        datum: 'NAD83',
        contourInterval: '10m',
        scale: '1:3,937',
        offlineAvailable:false,
        offlineComingSoon:false,
        downloadURL:'',
        img:wblg,
        center:[50.063541599446594, -122.94765848949606],
        maxBounds:[[50.03372798633418, -123.00894714633222], [50.12334633850441, -122.85628672950945]],
        minZoom:13,
        maxZoom:18,
        tileSize:1024,
        tileLayerBaseUrl:'https://d1epvrxk8md14j.cloudfront.net/mapData/wb/wb1024v4/600/',
        tileRange:tileRangeWB,
    },
    */
    spearhead: {
        mapName:'Spearhead Traverse',
        map:'spearhead',
        version: '2.0',
        lastUpdated: '2020',
        projection: 'UTM Zone 10N',
        datum: 'NAD83',
        contourInterval: '20m',
        scale: '1:10,597',
        offlineAvailable:false,
        offlineComingSoon:true,
        downloadURL:'https://d1epvrxk8md14j.cloudfront.net/mapData/spearhead/shtiles/{z}/{x}/{y}.jpeg',
        img:shlg,
        center:[50.0504331639911, -122.87196525397562],
        maxBounds:[[49.98292691723076, -123.01133478052596], [50.10811971405545, -122.75551127830491]],
        minZoom:13,
        maxZoom:17,
        defaultZoom:13,
        tileSize:256,
        tileLayerBaseUrl:'https://d1epvrxk8md14j.cloudfront.net/mapData/spearhead/shtiles/',
        tileRange:tileRangeSpearhead,
        layerType:'single'
    }
};
export {mapData, tileRangeSpearhead, tileRangeWB}
